export const DEFAULT_SOCIAL_EXTRA_PAYLOAD = { flow_type: 'implicit' };
export const DEFAULT_PASSWORD_LOGIN_EXTRA_PAYLOAD = { flow_type: 'password' };

export enum CAPTCHA_ACTIONS {
  LOGIN = 'login',
  REGISTER = 'register',
  STORED_VALUE_BALANCE = 'stored_value_balance',
  SUBMISSION = 'submission',
}

type CAPTCHA_FIELD_NAME = 'captcha_response';

export const CAPTCHA_CONFIG = {
  FIELD_NAME: 'captcha_response' as CAPTCHA_FIELD_NAME,
  API_ACTIONS: CAPTCHA_ACTIONS,
};

/**
 * TEAM-14519: shown when a required captcha token can't be obtained — on login, sign-up and the
 * gift-card balance check — in place of sending a request coo-api would refuse.
 */
export const CAPTCHA_FAILURE_COPY =
  "We couldn't complete a security check. Please refresh the page and try again.";

/**
 * TEAM-14520: shown when coo-api refuses a signed-in diner's order-history read (401/403) —
 * their session is gone, and they are routed to sign-in with this toast instead of an error.
 */
export const SESSION_ENDED_ORDER_HISTORY_COPY =
  'Your session has ended. Please sign in again to see your order history.';

export enum SIGNUP_OPTIONAL_FIELDS {
  TERMS_AND_CONDITIONS = 'terms_and_conditions',
  OPT_IN = 'opt_in',
  BIRTHDAY = 'birthday',
  REFERRAL_CODE = 'invite_code',
  ZIP_CODE = 'zip_code',
}

export enum EXTERNAL_AUTH_FEATURES {
  REQUIRES_EMAIL_VERIFICATION = 'requiresEmailVerification',
  SUPPORT_FOR_LOGIN_WITH_SOCIAL = 'supportForLoginWithSocial',
  SUPPORTS_STORED_CARDS = 'supportsStoredCards',
  SUPPORTS_SINGLE_FAVORITE_LOCATIONS = 'supportsSingleFavoriteLocations',
  SUPPORTS_STORED_ADDRESSES = 'supportsStoredAddresses',
  UPDATE_STORED_ADDRESSES = 'updateStoredAddresses',
  LIST_STORED_ADDRESSES = 'listStoredAddresses',
  DELETE_STORED_ADDRESSES = 'deleteStoredAddresses',
  SUPPORTS_ACCOUNT_DELETION = 'supportsAccountDeletion',
}
